import styled from 'styled-components'
import { BaseInput, BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

/*
  Os atalhos das variáveis, abaixo do texto. Mesmo desenho dos atalhos da tela de repasses
  (`pages/Admin/Payouts/styles.js`), sem o estado ativo.
*/
export const VariableRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
`

export const VariableButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 15px;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.2s;
  color: #606060;
  background-color: #FFFFFF;
  border: 1px solid #EDEDED;

  &:hover {
    border-color: #FFC100;
  }
`

export const HintText = styled(InfoText)`
  font-size: 12px;
  color: #808080;
  margin: 8px 0px 15px;
`
